import type { ShipId } from './catalog';
import { createEnemyShip } from './createEnemyShip';
import { createF22Raptor } from './createF22Raptor';
import { createSpaceship } from './createSpaceship';
import type * as THREE from 'three';

/** Build the playable craft mesh for the selected garage ship id. */
export function createPlayerShip(id: ShipId): THREE.Group {
  switch (id) {
    case 'arrowhead':
      return createEnemyShip();
    case 'f22':
      return createF22Raptor();
    case 'xwing':
    default:
      return createSpaceship();
  }
}
